export const createFilterData = (array: string[]) => {
  return array
    .filter((item) => item)
    .map((item) => {
      return {
        value: item,
        label: item,
      };
    });
};
